import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledDiv = styled('div')`
  width: 100%;
  height: ${({ fromRefund }) => (fromRefund ? 'auto' : '100%')};
  color: ${({ theme }) => theme.text.light};
  display: flex;
  justify-content: ${({ fromRefund }) =>
    fromRefund ? 'flex-start' : 'center'};
  align-items: center;
  font-style: italic;
`

const StyledP = styled('p')`
  text-align: center;
`

const EmptyResult = ({ children, ...rest }) => (
  <StyledDiv {...rest} className='empty-result'>
    <StyledP>{children}</StyledP>
  </StyledDiv>
)

EmptyResult.propTypes = {
  children: PropTypes.any,
}

export default EmptyResult
